import {
  ProfilePage,
  MembersPage,
  GendersPage,
  InvolvementTypesPage,
  SalutationsPage,
  PronounsPage,
  RidingsPage,
  SchoolsPage,
  DivisionsPage,
  CSRRolesPage,
  MembershipTypesPage,
  CommitteesPage,
  SchoolYearsPage,
  CommitteeGroupsPage,
  FundTypesPage,
  NonMembersPage,
  CallCategoriesPage,
  CallSubCategoriesPage,
  CallActionsPage,
  CallLogsPage,
  UsersPage,
  RolesPage,
  PermissionsPage,
  ContractTypesPage,
  EmploymentStatusesPage,
  DesignationsPage,
  AuditLogsPage,
  FundingPage,
  ProvincesPage
} from '~/pages';

export const appRoutes = [
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/home',
    element: <MembersPage />
  },
  {
    path: '/members',
    element: <MembersPage />
  },
  {
    path: '/admin/genders',
    element: <GendersPage />
  },
  {
    path: '/admin/involvement-types',
    element: <InvolvementTypesPage />
  },
  {
    path: '/admin/salutations',
    element: <SalutationsPage />
  },
  {
    path: '/admin/pronouns',
    element: <PronounsPage />
  },
  {
    path: '/admin/contract-types',
    element: <ContractTypesPage />
  },
  {
    path: '/admin/employment-statuses',
    element: <EmploymentStatusesPage />
  },
  {
    path: '/admin/ridings',
    element: <RidingsPage />
  },
  {
    path: '/schools',
    element: <SchoolsPage />
  },
  {
    path: '/admin/divisions',
    element: <DivisionsPage />
  },
  {
    path: '/csrroles',
    element: <CSRRolesPage />
  },
  {
    path: '/admin/membership-types',
    element: <MembershipTypesPage />
  },
  {
    path: '/committees',
    element: <CommitteesPage />
  },
  {
    path: '/admin/school-years',
    element: <SchoolYearsPage />
  },
  {
    path: '/admin/committee-groups',
    element: <CommitteeGroupsPage />
  },
  {
    path: '/admin/fund-types',
    element: <FundTypesPage />
  },
  {
    path: '/non-members',
    element: <NonMembersPage />
  },
  {
    path: '/admin/call-categories',
    element: <CallCategoriesPage />
  },
  {
    path: '/admin/call-sub-categories',
    element: <CallSubCategoriesPage />
  },
  {
    path: '/admin/call-actions',
    element: <CallActionsPage />
  },
  {
    path: '/call-logs',
    element: <CallLogsPage />
  },
  {
    path: '/users',
    element: <UsersPage />
  },
  {
    path: '/roles',
    element: <RolesPage />
  },
  {
    path: '/permissions',
    element: <PermissionsPage />
  },
  {
    path: '/admin/designations',
    element: <DesignationsPage />
  },
  {
    path: '/admin/audit-logs',
    element: <AuditLogsPage />
  },
  {
    path: '/funding',
    element: <FundingPage />
  },
  {
    path: '/admin/provinces',
    element: <ProvincesPage />
  },
];